<div class="content-box">
  <section class="pagina-servico" aria-labelledby="pagina-servico-titulo">
    <app-breadcrumb [pagina]="servico().titulo" [intermediarios]="trilha"></app-breadcrumb>

    <div class="pagina-servico-topo">
      <h1 class="pagina-servico-titulo" id="pagina-servico-titulo">{{ servico().titulo }}</h1>

      <div class="pagina-servico-acoes">
        <button type="button" class="pagina-servico-botao pagina-servico-solicitar" (click)="irParaLogin()">
          <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
          Solicitar
        </button>

      </div>
    </div>

    @if (servico().banner; as banner) {
      <img
        class="pagina-servico-banner"
        [ngSrc]="banner"
        width="1200"
        height="360"
        priority
        alt=""
      />
    }

    <app-etapas-servico
      #trilhaEtapas
      [etapas]="etapas"
      [etapaAtual]="etapaAtual()"
      [etapaLiberada]="etapaLiberada()"
      [mensagemBloqueio]="
        etapaLiberada() === 0
          ? 'Entre com login, gov.br ou escolha solicitar anonimamente para liberar'
          : 'Conclua a etapa anterior para liberar'
      "
      (selecionar)="irParaEtapa($event)"
    ></app-etapas-servico>

    @switch (etapaAtualId()) {
      @case ('informacoes') {
        <app-etapa-informacoes
          [descricao]="servico().descricao"
          [carta]="carta()"
          [cartaCarregando]="cartaCarregando()"
          [cartaFalhou]="cartaFalhou()"
          (recarregarCarta)="recarregarCarta()"
          [sessaoIniciada]="sessaoIniciada()"
          [focarLogin]="focarLogin()"
          (autenticado)="autenticar()"
          (saiu)="encerrarSessao()"
          (acessarGov)="seguirSemIdentificacao()"
          (solicitar)="solicitar()"
          (seguirAnonimo)="seguirSemIdentificacao()"
        ></app-etapa-informacoes>
      }
      @case ('solicitacao') {
        <app-etapa-solicitacao></app-etapa-solicitacao>
      }
      @case ('anexos') {
        <app-etapa-anexos></app-etapa-anexos>
      }
      @case ('confirmacao') {
        <app-etapa-confirmacao
          [servico]="servico().titulo"
          (novaSolicitacao)="novaSolicitacao()"
        ></app-etapa-confirmacao>
      }
    }

    @if (etapaAtual() > 0 && !concluida()) {
      <div class="pagina-servico-navegacao">
        @if (etapaAtual() > 1) {
          <button type="button" class="pagina-servico-botao pagina-servico-voltar" (click)="voltar()">
            <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
            Voltar
          </button>
        }

        @if (store.preenchido()) {
          <button type="button" class="pagina-servico-botao pagina-servico-cancelar" (click)="cancelarSolicitacao()">
            Cancelar solicitação
          </button>
        }

        @if (etapaAtual() === etapas.length - 1) {
          <button
            type="button"
            class="pagina-servico-botao pagina-servico-avancar"
            [disabled]="!store.podeConcluir() || enviando()"
            [attr.aria-busy]="enviando()"
            (click)="concluir()"
          >
            <i-lucide name="check" size="16" aria-hidden="true"></i-lucide>
            @if (enviando()) {
              Enviando...
            } @else if (store.exigeAgendamento()) {
              Concluir agendamento
            } @else {
              Concluir solicitação
            }
          </button>
        } @else {
          <button type="button" class="pagina-servico-botao pagina-servico-avancar" (click)="avancar()">
            Avançar
            <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
          </button>
        }
      </div>
    }
  </section>
</div>
